import React, { FC } from 'react';
import { PageContainer } from '@/ui/components';
import { LoadLaneStatusPage } from './components/LoadLaneStatusPage';

export const loadlanes: FC = () => (
  <PageContainer
    style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}
  >
    <LoadLaneStatusPage />
  </PageContainer>
);
